import { ICartSettings } from '@model';

export interface IEcommerceServices {
  settings?: ICartSettings;
  gifts: boolean;
}

export const getCartServices = (services?: IEcommerceServices): string[] => {
  const activeServices: string[] = [];

  if (services === undefined) {
    return activeServices;
  }

  if (services.settings !== undefined) {
    if (services.settings.insuranceEnabled) {
      activeServices.push('insurance');
    }
    if (services.settings.ecoPackagingEnabled) {
      activeServices.push('ecoPackaging');
    }
    if (services.settings.fundRaising.active) {
      activeServices.push('fundRaising');
    }
    if (services.settings.giftPackaging.giftCardEnabled) {
      activeServices.push('giftPackaging');
    }
  }

  if (services.gifts) {
    activeServices.push('gifts');
  }

  return activeServices;
};
